export default __webpack_public_path__ + "static/media/yes.f5bdf503.png";